import {useInView} from "react-intersection-observer";
import {useFetchPrestataires} from "../../../hooks/usePrestatires";
import PrestataireCard from "./Card";
import {useEffect} from "react";
import QueryErrorState from "../../components/shared/QueryErrorState";
import {useTranslation} from "react-i18next";
import EmptyState from "../../components/shared/EmptyState";

const ListPrestataires = ({filter}) => {
  const {t} = useTranslation();
  const {
    prestataires,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    refetch,
  } = useFetchPrestataires(filter);

  const {ref, inView} = useInView({
    threshold: 1,
  });

  // Fetch the next page when the "inView" changes to true (when the observer hits the bottom of the list)
  useEffect(() => {
    if (inView && hasNextPage && !isFetching && !isLoading) {
      fetchNextPage();
    }
  }, [
    fetchNextPage,
    hasNextPage,
    inView,
    isFetching,
    isFetchingNextPage,
    isLoading,
  ]);

  if (isLoading) {
    return (
      <div
        className="w-full min-h-[260px] bg-white rounded-2xl flex flex-col gap-3 items-center justify-center text-[#7E7E7E]"
        role="status"
        aria-live="polite"
      >
        <div className="w-10 h-10 rounded-full border-4 border-solid border-[#D6E2EF] border-t-[#1A64B9] animate-spin"></div>
        <span className="text-sm font-medium">{t("loadingResults")}</span>
      </div>
    );
  }

  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  return (
    <>
      {isFetching && !isFetchingNextPage && (
        <div
          className="w-full bg-[#E2F0FF] text-[#1A64B9] rounded-lg px-3 py-2 flex items-center justify-center gap-2 text-xs font-medium"
          role="status"
          aria-live="polite"
        >
          <i className="fi fi-rr-spinner animate-spin flex items-center"></i>
          {t("updatingResults")}
        </div>
      )}
      {prestataires?.pages?.length ? (
        prestataires.pages.map((prestataire) => (
          <div className="w-full " key={prestataire.id}>
            <PrestataireCard prestataire={prestataire} />
          </div>
        ))
      ) : (
        <EmptyState className="w-full bg-white h-[50vh] py-3 rounded-2xl" />
      )}
      {/* Loader for fetching more data */}
      {isFetchingNextPage && (
        <div className="w-full">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      )}
      {/* Sentinel for infinite scrolling */}
      {hasNextPage && (
        <div ref={ref} className="w-full">
          {t("loadingMoreProviders")}
        </div>
      )}
    </>
  );
};

export default ListPrestataires;
